import { Component, Input } from '@angular/core';

@Component({
    selector: 'cart-empty',
    templateUrl: './cart.empty.component.html',
    styleUrls: ['./../cart.component.scss']
})
export class CartEmptyComponent {
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/cart/empty/cart.empty.component.ts